import { render, staticRenderFns } from "./AppointmentEditView.vue?vue&type=template&id=bf334158"
import script from "./AppointmentEditView.vue?vue&type=script&lang=ts"
export * from "./AppointmentEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports